module.exports = __webpack_public_path__ + "static/KC12-c7a797d24e97b56c27c86d120aa90329.png";